import { j as i } from "./jsx-runtime-DmTjM30f.mjs";
import { c as s } from "./client-COlxxEJZ.mjs";
import { a, P as c } from "./pc-dialog-sheet-DNAOAX5p.mjs";
const l = "dialog-container", A = (e) => {
  const o = e.id || m(e.title || "") || "dialog";
  if (typeof document > "u") return { destroy: () => {
  } };
  if (document.querySelector(`.${l}.${o}`))
    return { destroy: () => {
    } };
  const n = e.id || `dialog_${Date.now()}`, t = u(o, n), r = s(t);
  return r.render(/* @__PURE__ */ i.jsx(a, { ...e, show: !0 })), {
    destroy: () => {
      r.render(
        /* @__PURE__ */ i.jsx(
          a,
          {
            ...e,
            onAnimationEnd: () => {
              var d;
              r.unmount(), (d = t.parentElement) == null || d.removeChild(t);
            },
            show: !1
          }
        )
      );
    }
  };
};
function u(e, o) {
  const n = document.querySelector("body"), t = document.createElement("div");
  return t.className = `${l} ${e} ${o}`, n.appendChild(t);
}
function m(e) {
  try {
    return `nol_${e.split("").reduce((o, n) => {
      const t = (o << 5) - o + n.charCodeAt(0);
      return t & t;
    }, 0).toString()}`;
  } catch {
    return "";
  }
}
const g = "pc-dialog-sheet-container", C = (e) => {
  if (typeof document > "u") return { destroy: () => {
  } };
  const o = e.id || `dialog_${Date.now()}`, n = y(o), t = s(n);
  return t.render(/* @__PURE__ */ i.jsx(c, { ...e, show: !0 })), {
    destroy: () => {
      t.render(
        /* @__PURE__ */ i.jsx(
          c,
          {
            ...e,
            onAnimationEnd: () => {
              var r;
              t.unmount(), (r = n.parentElement) == null || r.removeChild(n);
            },
            show: !1
          }
        )
      );
    }
  };
};
function y(e) {
  const o = document.querySelector("body"), n = document.createElement("div");
  return n.className = `${g} ${e}`, o.appendChild(n);
}
export {
  C as a,
  A as s
};
